var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-cropper d-flex justify-center"},[_c('img',{ref:"image",attrs:{"src":_vm.src,"alt":"Picture"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }